import React, { useRef } from 'react';
var VeltCommentSidebarV2ListGroupHeaderSeparator = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-list-group-header-v2-separator", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2ListGroupHeaderSeparator;
